var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.pendingRevision)?_c('el-alert',{attrs:{"title":"Kopia robocza","show-icon":"","closable":false,"type":"warning"}},[_c('span',[_vm._v("Edytujesz kopie roboczą, zmiany nie zostaną opublikowane do momentu Zatwierdzenia formularza.")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }